import { useNavigate } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import PdfExport from "../../../pdfExport";
import { socials } from "../../../../data/Socials";
import TestTitle from "../../testCommon/TestTitle";
import UserComment from "../../testCommon/UserComment";
import SurveyImage from "../../../../assets/icons/test-survey.png";

const Survey = ({ testInfo, testResults, footerButtons }: any) => {
  const navigate = useNavigate();

  const BodybonSocials = () => {
    return (
      <div className="bg-pr_green rounded-xl p-6 flex flex-col w-full">
        <h2 className="font-rokh font-[900] mt-2 text-lg lg:text-xl text-black drop-border flex-1">
          توی شبکه‌های اجتماعی هم کنار بادی‌بان باش!
        </h2>
        <div className="flex items-center justify-end mt-8 mb-4 lg:mb-1 lg:mt-20 gap-2">
          {socials.map((socialItem: any) => (
            <a
              href={socialItem.link}
              key={socialItem.title}
              target="_blank"
              className="p-3 rounded-full w-18 h-18 flex items-center justify-center border bg-white duration-500"
            >
              <img src={socialItem.icon} width={30} alt={socialItem.title} />
            </a>
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className="flex-1">
      <Fade triggerOnce>
        <TestTitle
          title="نظرسنجی  و دریافت نتیجه"
          subtitle="دریافت نتیجه تحلیل آزمایش و نظرسنجی"
          icon={SurveyImage}
        />

        <UserComment />

        <div className="mt-5 flex flex-col lg:flex-row gap-5">
          <div className="flex-[1]">
            <PdfExport testInfo={testInfo} testResults={testResults} />
          </div>
          <div className="flex-[3]">
            <BodybonSocials />
          </div>
        </div>

        {footerButtons}
      </Fade>
    </div>
  );
};

export default Survey;
